import {
  debounceTime,
  distinctUntilChanged,
  map,
  merge,
  Observable,
} from 'rxjs';
import { action$, ofType } from '@ardoq/rxbeach';
import { triggerFiltersChangedEvent } from './FilterActions';
import { isEqual } from '@ardoq/common-helpers';
import { filterInterface } from '@ardoq/filter-interface';
import { BACKBONE_MODEL_BATCH_TIMEOUT_MS } from '@ardoq/global-consts';
import { FormattingAndLabelRules } from '@ardoq/data-model';
import { references$ } from 'streams/references/references$';

export const formattingAndLabelRules$: Observable<FormattingAndLabelRules> =
  merge(action$.pipe(ofType(triggerFiltersChangedEvent)), references$).pipe(
    debounceTime(BACKBONE_MODEL_BATCH_TIMEOUT_MS),
    map(filterInterface.getFormattingAndLabelRules),
    distinctUntilChanged(isEqual)
  );
